module.exports = __webpack_public_path__ + "static/fonts/FaktSoftPro-Medium.a941849c.woff2";